<div fxLayout="row" [style]="style">
  <div class="from" *ngIf="!msg.sent">{{msg.msg.from}}:</div>
  <div class="me" *ngIf="msg.sent">{{msg.msg.from}}:</div>
  <div class="msg">{{msg.msg.text}}</div>
</div>
